<div class="login-container p-3 poppins">
  <div class="register-box">
    <div *ngIf="!routeWizard">
      <h1 class="poppins" translate>
        components.registro.welcomeTo
        <span class="label-inviertis ms-0">Inviertis</span>
      </h1>
    </div>
    <div>
      <div class="col-md-10 mt-3 mx-auto" style="max-width: 600px">
        <div style="width: 100%; display: flex">
          <div class="col-6 text-center" translate>
            <i class="fa fa-user fa-2x social-icons grey-color"></i><br />
            <input
              type="radio"
              name="registerType"
              value="user"
              id="particular-btn"
              [(ngModel)]="registerType"
              (ngModelChange)="onRegisterTypeChange()"
            />
            components.registro.individual
          </div>
          <div class="col-6 text-center" translate>
            <i class="fa fa-users fa-2x social-icons grey-color"></i><br />
            <input
              type="radio"
              name="registerType"
              value="enterprise"
              id="enterprise-btn"
              [(ngModel)]="registerType"
              (ngModelChange)="onRegisterTypeChange()"
            />
            components.registro.representCompany
          </div>
        </div>
        <div class="dropdown-divider divider-margin"></div>
      </div>

      <div class="col-md-10 mt-3 mx-auto">
        <div class="row" style="max-width: 100%; margin: 0">
          <div class="card-body">
            <form (ngSubmit)="register()" [formGroup]="registerForm" novalidate id="form_registry">
              <div class="form-group">
                <label
                  class="d-block py-1"
                  *ngIf="registerType === 'enterprise'"
                  (click)="onChangeType()"
                >
                  <input
                    id="company-name-inp"
                    type="text"
                    class="form-control"
                    formControlName="company_name"
                    placeholder="{{
                      'components.registro.companyName' | translate
                    }}"
                  />
                  <span hidden translate>components.registro.companyName</span>
                  <div
                    *ngIf="
                      registerForm.controls.company_name.invalid &&
                      (registerForm.controls.company_name.dirty ||
                        registerForm.controls.company_name.touched)
                    "
                  >
                    <small
                      *ngIf="
                        registerForm.controls.company_name.errors?.required
                      "
                      class="text-danger"
                      translate
                    >
                      components.registro.companyNameRequired
                    </small>
                    <small
                      *ngIf="
                        registerForm.controls.company_name.errors?.maxlength
                      "
                      class="text-danger"
                      translate
                    >
                      components.registro.companyNameMaxChars
                    </small>
                  </div>
                </label>

                <label
                  class="d-block py-1"
                  *ngIf="registerType === 'enterprise'"
                  (click)="onChangeType()"
                >
                  <input
                    id="cif-inp"
                    type="text"
                    class="form-control"
                    formControlName="cif"
                    placeholder="{{
                      'components.registro.companyCif' | translate
                    }}"
                    translate
                  />
                  <div
                    *ngIf="
                      registerForm.controls.cif.invalid &&
                      (registerForm.controls.cif.dirty ||
                        registerForm.controls.cif.touched)
                    "
                  >
                    <small
                      *ngIf="registerForm.controls.cif.errors?.pattern"
                      class="text-danger"
                      translate
                    >
                      components.registro.onlyNumbersAndLetters
                    </small>
                    <small
                      *ngIf="registerForm.controls.cif.errors?.maxlength"
                      class="text-danger"
                      translate
                    >
                      components.registro.cifMaxChars
                    </small>
                  </div>
                </label>

                <label class="d-block py-1">
                  <input
                    id="firstname-inp"
                    type="text"
                    class="form-control"
                    formControlName="first_name"
                    autocomplete="first_name"
                    placeholder="{{ 'Nombre' | translate }}"
                  />
                  <span hidden translate>components.registro.name</span>
                  <div
                    *ngIf="
                      registerForm.controls.first_name.invalid &&
                      (registerForm.controls.first_name.dirty ||
                        registerForm.controls.first_name.touched)
                    "
                  >
                    <small
                      *ngIf="registerForm.controls.first_name.errors?.required"
                      class="text-danger"
                      translate
                    >
                      components.registro.nameRequired
                    </small>
                    <small
                      *ngIf="registerForm.controls.first_name.errors?.maxlength"
                      class="text-danger"
                      translate
                    >
                      components.registro.nameMaxChars
                    </small>
                    <small
                      *ngIf="registerForm.controls.first_name.errors?.pattern"
                      class="text-danger"
                      translate
                    >
                      components.registro.noSpecialChars
                    </small>
                  </div>
                </label>

                <label class="d-block py-1">
                  <input
                    id="lastname-inp"
                    type="text"
                    class="form-control"
                    formControlName="last_name"
                    autocomplete="last_name"
                    placeholder="{{ 'Apellido' | translate }}"
                  />
                  <span hidden>Last Name</span>
                  <div
                    *ngIf="
                      registerForm.controls.last_name.invalid &&
                      (registerForm.controls.last_name.dirty ||
                        registerForm.controls.last_name.touched)
                    "
                  >
                    <small
                      *ngIf="registerForm.controls.last_name.errors?.required"
                      class="text-danger"
                      translate
                    >
                      components.registro.surnameRequired
                    </small>
                    <small
                      *ngIf="registerForm.controls.last_name.errors?.maxlength"
                      class="text-danger"
                      translate
                    >
                      components.registro.surnameMaxChars
                    </small>
                    <small
                      *ngIf="registerForm.controls.last_name.errors?.pattern"
                      class="text-danger"
                      translate
                    >
                      components.registro.surnameNoSpecialChars
                    </small>
                  </div>
                </label>

                <label class="d-block py-1">
                  <app-countries-autocomplete
                    [control]="registerForm.get('code_country')"
                  ></app-countries-autocomplete>
                </label>

                <label class="d-block py-1">
                  <input
                    appMaxLength
                    [maxLength]="12"
                    id="phone-inp"
                    class="form-control"
                    formControlName="phone"
                    placeholder="{{ 'Teléfono' | translate }}"
                    type="text"
                  />
                  <span hidden translate>components.registro.telephone</span>
                  <div
                    *ngIf="
                      registerForm.controls.phone.invalid &&
                      (registerForm.controls.phone.dirty ||
                        registerForm.controls.phone.touched)
                    "
                  >
                    <small
                      *ngIf="registerForm.controls.phone.errors?.required"
                      class="text-danger"
                      translate
                    >
                      components.registro.telephoneRequired
                    </small>
                    <small
                      *ngIf="registerForm.controls.phone.errors.pattern"
                      class="text-danger"
                      translate
                    >
                      components.registro.onlyNumbers
                    </small>
                  </div>
                </label>

                <label class="d-block py-1">
                  <input
                    id="email-inp"
                    type="email"
                    class="form-control"
                    formControlName="email"
                    [placeholder]="'Email'"
                  />
                  <span hidden>Email</span>
                  <div
                    *ngIf="
                      registerForm.controls.email.invalid &&
                      (registerForm.controls.email.dirty ||
                        registerForm.controls.email.touched)
                    "
                  >
                    <small
                      *ngIf="registerForm.controls.email.errors?.required"
                      class="text-danger"
                      translate
                    >
                      components.registro.emailRequired
                    </small>
                    <small
                      *ngIf="registerForm.controls.email.errors?.minlength"
                      class="text-danger"
                      translate
                    >
                      components.registro.emailMinChars
                    </small>
                    <small
                      *ngIf="registerForm.controls.email.errors?.maxlength"
                      class="text-danger"
                      translate
                    >
                      components.registro.emailMaxChars
                    </small>
                  </div>
                </label>
                <div class="d-block py-1">
                  <select
                    class="form-control desplegable option-title"
                    aria-label="Default select example"
                    (change)="onChangeTipoUser($event)"
                  >
                    <option disabled selected translate>
                      components.registro.whatCameFor
                    </option>
                    <option
                      *ngFor="let item of userTypes"
                      [selected]="item.selected"
                      [disabled]="item.isDisabled"
                      class="form-control opciones"
                      [id]="item.id_user_type"
                      translate
                    >
                      components.registro.{{ item.description }}
                    </option>
                  </select>
                  <div *ngIf="registerForm.controls.email.touched">
                    <small *ngIf="!tipoDeUsuario" class="text-danger" translate>
                      components.registro.selectOption
                    </small>
                  </div>
                </div>
                <div *ngIf="esInversor" class="d-block py-1">
                  <select
                    class="form-control desplegable option-title"
                    aria-label="Default select example"
                    (change)="onChangeTipoInversor($event)"
                  >
                    <option disabled selected translate>
                      components.registro.firstTimeInvesting
                    </option>
                    <option
                      *ngFor="let item of arrayTipoInversor"
                      [selected]="item.selected"
                      [disabled]="item.isDisabled"
                      class="form-control opciones"
                      translate
                    >
                      components.registro.{{ item.name }}
                    </option>
                  </select>
                  <div *ngIf="registerForm.controls.email.touched">
                    <small
                      *ngIf="tipoDeInversor != 1 && tipoDeInversor != 0"
                      class="text-danger"
                      translate
                    >
                      components.registro.selectOption
                    </small>
                  </div>
                </div>

                <label class="d-block py-1">
                  <div class="input-group">
                    <input
                      aria-describedby="btnGroupAddon"
                      id="password-inp"
                      [type]="showPassword ? 'password' : 'text'"
                      min="8"
                      max="20"
                      class="form-control"
                      formControlName="password"
                      placeholder="{{ 'Contraseña' | translate }}"
                      required
                    />
                    <div class="input-group-text" (click)="hidePassword()">
                      <i class="fas fa-eye"></i>
                    </div>
                  </div>
                  <span hidden>Contraseña</span>
                  <div
                    *ngIf="
                      registerForm.controls.password.invalid &&
                      (registerForm.controls.password.dirty ||
                        registerForm.controls.password.touched)
                    "
                  >
                    <small
                      *ngIf="registerForm.controls.password.errors?.required"
                      class="text-danger"
                      translate
                    >
                      components.registro.passwordRequired
                    </small>
                    <small
                      *ngIf="registerForm.controls.password.errors?.pattern"
                      class="text-danger"
                      translate
                    >
                      components.registro.passwordValidation
                    </small>
                    <small
                      *ngIf="registerForm.controls.password.errors?.maxlength"
                      class="text-danger"
                      translate
                    >
                      components.registro.passwordMaxChars
                    </small>
                  </div>
                </label>

                <label class="d-block py-1">
                  <input
                    id="reenter-password-inp"
                    [type]="showPassword ? 'password' : 'text'"
                    min="8"
                    max="20"
                    class="form-control"
                    formControlName="reenterPassword"
                    placeholder="{{ 'Repetir contraseña' | translate }}"
                    required
                  />
                  <span hidden>Repetir contraseña</span>
                  <small
                    *ngIf="
                      registerForm.controls.reenterPassword.touched &&
                      !matchPasswords()
                    "
                    class="text-danger"
                    translate
                  >
                    components.registro.passwordValidationwordsDoNotMatch
                  </small>
                  <small
                    *ngIf="
                      registerForm.controls.reenterPassword.invalid &&
                      (registerForm.controls.reenterPassword.dirty ||
                        registerForm.controls.reenterPassword.touched)
                    "
                    class="text-danger"
                  >
                    Repetir contraseña
                  </small>
                </label>
              </div>

              <div
                class="form-check margin-terms"
                style="max-width: 571px"
                translate
              >
                <div>
                  <p class="margin-zero" translate>
                    components.registro.byClickingOn
                    <b><i translate>components.registro.signUp</i></b>
                    components.registro.acceptThe
                    <a
                      [routerLink]="[
                        '/' +
                          (translateService.currentLang === 'es'
                            ? 'es'
                            : 'en') +
                          '/terminos-condiciones'
                      ]"
                      placement="bottom"
                      target="_blank"
                      translate
                    >
                      components.registro.termsAndConditions
                    </a>
                    ,
                    <a
                      [routerLink]="[
                        '/' +
                          (translateService.currentLang === 'es'
                            ? 'es'
                            : 'en') +
                          '/politica-de-privacidad'
                      ]"
                      placement="bottom"
                      target="_blank"
                      translate
                    >
                      components.registro.privacyPolicies</a
                    >
                    components.registro.ofInviertisAndUnderstand
                    <a
                      [routerLink]="[
                        '/' +
                          (translateService.currentLang === 'es'
                            ? 'es'
                            : 'en') +
                          '/aviso-legal'
                      ]"
                      placement="bottom"
                      target="_blank"
                      translate
                    >
                      components.registro.relationshipWithInviertis</a
                    >
                  </p>
                </div>
                <br />
                <input
                  class="form-check-input prov-check-input"
                  type="checkbox"
                  id="todos"
                  [(ngModel)]="acceptNotifications"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div>
                  <p class="margin-zero" translate>
                    components.registro.wantReceiveInfo
                  </p>
                </div>
              </div>
              <button
                id="btn-form-registro"
                class="btn btn-primary w-100 register-button boton-registrarse"
                type="submit"
                [disabled]="
                  registerForm.invalid ||
                  !matchPasswords() ||
                  isLoading ||
                  !tipoDeUsuario ||
                  !esCorrecto
                "
                translate
              >
                components.registro.signUp
                <i
                  class="fas fa-circle-o-notch ms-1 fa-spin"
                  [hidden]="!isLoading"
                ></i>
              </button>
              <div class="text-center" *ngIf="!routeWizard">
                <p translate>
                  components.registro.alreadyMember
                  <a
                    [routerLink]="[
                      '/' +
                        (translateService.currentLang === 'es' ? 'es' : 'en') +
                        '/ingresar'
                    ]"
                    translate
                    >components.registro.loginHere</a
                  >
                </p>
              </div>
            </form>

            <!-- <div *ngIf="registerType === 'user' && !registerWithSocial">
              <div class="card text-center card-borderless">
                <button
                  id="google-signin-btn"
                  class="btn btn-primary btn-google btn-margin social-login-btn"
                  (click)="signUpWithGoogle()"
                  translate
                >
                  <i class="fab fa-google fa-2x social-icons"></i>
                  components.registro.signUp con Google
                </button>
                <button
                  id="fb-signin-btn"
                  class="btn btn-primary btn-facebook btn-margin social-login-btn"
                  (click)="signUpWithFB()"
                  translate
                >
                  <i class="fab fa-facebook fa-2x social-icons"></i>
                  components.registro.signUp con Facebook
                </button>
              </div>
            </div> -->
            <br />

            <div class="text-center">
              <em
                class="fas fa-circle-o-notch ms-1 fa-spin fa-2x"
                enabled
                [hidden]="!isLodingModal"
              ></em>
            </div>

            <div *ngIf="registerType === 'user' && !registerWithSocial">
              <h4 translate>
                &nbsp;&nbsp; components.registro.orSignUpWith &nbsp;&nbsp;
              </h4>
              <div class="text-center">
                <i
                  id="btn_register_google"
                  class="fab fa-google fa-2x social-icons"
                  (click)="googleRequest.requestAccessToken()"
                ></i>
                &nbsp;&nbsp;
                <i
                  id="btn_register_facebook"
                  class="fab fa-facebook fa-2x social-icons"
                  (click)="signUpWithFB()"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #exito let-modal>
  <div class="container">
    <div class="col-12" style="padding: 20px 0 20px 0">
      <button type="button" class="close" (click)="closeModalSaveSearch()">
        &times;
      </button>
      <div class="text-center" style="padding: 20px 0 20px 0">
        <img
          src="favicon.ico"
          width="30"
          height="30"
          style="margin-right: 2%"
          loading="lazy"
          alt="logo de inviertis"
        />
        <br /><br />
        <h1 style="font-size: 40px" translate>
          <strong translate> components.message.thanksForRegistering</strong>
        </h1>
        <h3 translate>components.message.verifyEmailToLogin</h3>
        <small style="color: #828282; font-size: 14.5px" translate>
          components.buyOptions.¿Tienes alguna duda?
        </small>
        <a
          [routerLink]="[
            '/' +
              (translateService.currentLang === 'es' ? 'es' : 'en') +
              '/sobre-nosotros/contacto'
          ]"
          (click)="modal.dismiss('Close button click')"
          translate
          >components.buyOptions.preguntarle a un agente inviertis aquí</a
        >
      </div>
    </div>
  </div>
</ng-template>
